import { type ConfigurationPropertyStore } from 'stores/mobx/configuration-property.store';
import { type GroupedRowType } from 'utils/table-group-by.utils';
import { typeStyle } from 'constants/typography';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import Info from 'components/common/info';

interface SensitiveVariablesGroupHeaderProps {
  record: GroupedRowType<ConfigurationPropertyStore>;
  titleParts: { text: string; isBold?: boolean }[];
  info?: { id: string; values?: Record<string, any> };
  'data-e2e'?: string;
}

export const VariablesGroupHeader: React.FC<SensitiveVariablesGroupHeaderProps> = ({
  record,
  titleParts,
  info,
  'data-e2e': dataE2e
}) => {
  return (
    <GroupTitle data-e2e={dataE2e}>
      <span>
        {titleParts.map(({ text, isBold }, index) =>
          isBold ? <BoldGroupPart key={index}>{text}</BoldGroupPart> : text
        )}
      </span>
      <ChildrenCounter>{record.children.length}</ChildrenCounter>
      {info && <Info tooltip={<FormattedMessage id={info.id} values={info.values} />} />}
    </GroupTitle>
  );
};

const BoldGroupPart = styled.span`
  ${typeStyle.bodyMdBold}
`;

// A count badge; the Table page draws these as a tinted pill rather than a soft-cornered box.
const ChildrenCounter = styled.div`
  display: flex;
  justify-content: center;

  ${typeStyle.labelSm}
  align-items: center;
  height: var(--spacing-xxl);
  min-width: var(--spacing-xxl);
  background: var(--surface-tint-gray);
  color: var(--text-secondary);
  border-radius: var(--border-radius-round);
  padding: 0 var(--padding-xxxs);
`;

const GroupTitle = styled.span`
  display: flex;

  ${typeStyle.bodyMd}
  color: var(--text-heading);
  gap: var(--spacing-xs);

  cursor: pointer;
`;
